import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { closeAllModals } from '../../../../../actions/modalActions';
import { ReactComponent as Close } from '../../../../../icons/close-button.svg';
import LocationApprovalRequired from '../../../../base/misc/locationApprovalRequired';
import { A } from '../../../../base/typography';
import { MyShipmentsMapContainer } from '../../../../map/mapContainer';
import * as StyledModals from '../../myShipmentsModals.styles';

interface Props {}

const DeliveryOptionsMap: FC<Props> = () => {
	const { t } = useTranslation('myShipments');
	const dispatch = useDispatch<any>();
	const closeModal = () => {
		dispatch(closeAllModals());
		document.body.style.overflow = 'unset';
	};
	document.body.style.overflow = 'hidden';

	const [lat, setLat] = useState(64.1256369);
	const [lng, setLng] = useState(-21.8756546);

	const success = postition => {
		setLat(postition.coords.latitude);
		setLng(postition.coords.longitude);
	};
	navigator.geolocation.getCurrentPosition(success, () => {});

	const onMarkerClick = item => {
		// TODO: !!!

		console.log('>>> ' + item.longitude);
		console.log('>>> ' + item.latitude);

		closeModal();
	};
	return (
		<StyledModals.Wrapper>
			<StyledModals.Heading>
				<div>{t('page-settings.chooseDeliveryOption')}</div>
				<A onClick={closeModal}>
					<Close />
				</A>
			</StyledModals.Heading>
			<StyledModals.MapContainer>
				<LocationApprovalRequired>
					<MyShipmentsMapContainer
						lat={lat}
						lng={lng}
						zoom={12}
						selectedMarker={null}
						onMarkerClick={onMarkerClick}
					/>
				</LocationApprovalRequired>
			</StyledModals.MapContainer>
		</StyledModals.Wrapper>
	);
};

export default DeliveryOptionsMap;
